import apiClient from './authService';

const templateService = {
  // Get all templates with pagination
  getTemplates: async (page = 0, size = 10, sortBy = 'createdAt', sortDir = 'desc') => {
    const response = await apiClient.get('/templates', {
      params: { page, size, sortBy, sortDir }
    });
    return response.data;
  },

  // Get all templates without pagination
  getAllTemplates: async () => {
    const response = await apiClient.get('/templates/all');
    return response.data;
  },

  // Get template by ID
  getTemplate: async (templateId) => {
    const response = await apiClient.get(`/templates/${templateId}`);
    return response.data;
  },

  // Create new template
  createTemplate: async (templateData) => {
    const response = await apiClient.post('/templates', templateData);
    return response.data;
  },

  // Update template
  updateTemplate: async (templateId, templateData) => {
    const response = await apiClient.put(`/templates/${templateId}`, templateData);
    return response.data;
  },

  // Delete template
  deleteTemplate: async (templateId) => {
    const response = await apiClient.delete(`/templates/${templateId}`);
    return response.data;
  },

  // Submit template to WhatsApp
  submitTemplateToWhatsApp: async (templateId) => {
    const response = await apiClient.post(`/templates/${templateId}/submit`);
    return response.data;
  },

  // Resubmit template to WhatsApp (deletes old template first)
  resubmitTemplateToWhatsApp: async (templateId) => {
    const response = await apiClient.post(`/templates/${templateId}/resubmit`);
    return response.data;
  },

  // Get templates by status
  getTemplatesByStatus: async (status) => {
    const response = await apiClient.get(`/templates/status/${status}`);
    return response.data;
  },

  // Get templates by category
  getTemplatesByCategory: async (category) => {
    const response = await apiClient.get(`/templates/category/${category}`);
    return response.data;
  },

  // Get templates by language
  getTemplatesByLanguage: async (language) => {
    const response = await apiClient.get(`/templates/language/${language}`);
    return response.data;
  },

  // Get approved templates
  getApprovedTemplates: async () => {
    const response = await apiClient.get('/templates/approved');
    return response.data;
  },

  // Get public templates with pagination
  getPublicTemplates: async (page = 0, size = 12, sortBy = 'createdAt', sortDir = 'desc') => {
    const response = await apiClient.get('/templates/public', {
      params: { page, size, sortBy, sortDir }
    });
    return response.data;
  },

  // Search templates with criteria
  searchTemplates: async (filters = {}) => {
    const {
      search,
      status,
      category,
      language,
      page = 0,
      size = 10,
      sortBy = 'createdAt',
      sortDir = 'desc'
    } = filters;

    const response = await apiClient.get('/templates/search', {
      params: {
        search,
        status,
        category,
        language,
        page,
        size,
        sortBy,
        sortDir
      }
    });
    return response.data;
  },

  // Check if template name exists
  checkTemplateName: async (templateName) => {
    const response = await apiClient.get('/templates/check-name', {
      params: { templateName }
    });
    return response.data;
  },

  // Get template count by status
  getTemplateCountByStatus: async (status) => {
    const response = await apiClient.get(`/templates/count/${status}`);
    return response.data;
  },

  // Import templates from WhatsApp Business Manager
  importTemplatesFromWhatsApp: async () => {
    const response = await apiClient.post('/templates/import');
    return response.data;
  },

  // Sync all templates with WhatsApp Business Manager
  syncTemplatesWithWhatsApp: async () => {
    const response = await apiClient.post('/templates/sync');
    return response.data;
  },

  // Sync specific template with WhatsApp Business Manager
  syncTemplateWithWhatsApp: async (templateId) => {
    const response = await apiClient.post(`/templates/${templateId}/sync`);
    return response.data;
  },

  // Send test bulk messages
  sendTestMessages: async (requestData) => {
    const response = await apiClient.post('/bulk-messages/test', requestData);
    return response;
  },

};

export { templateService };
